import { Icon } from '@ps/isp-web-component-library';
import { Padlock } from '@ps/isp-web-component-library/icons/Padlock';
import type { Odds as OddsType } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Odds } from '@swf/sports/components';

import {
  TXTWCL_Added_To_Bet_Slip,
  TXTWCL_SP,
  TXTWCL_SUSPENDED,
  TXTWCL_Starting_Price,
  TXTWCL_handicap_value_N0
} from './Content.messages.json';
import styles from './Content.scss';

export interface OwnProps {
  odds?: OddsType;
  isLocked: boolean;
  selectionText?: string | ((arg: boolean) => JSX.Element);
  isNonRunner?: boolean;
  isStartingPriceMarket: boolean;
  isHandicap?: boolean;
  isVacantTrap?: boolean;
  shouldShowAddedToBetSlip?: boolean;
  isSelected?: boolean;
}

export type Props = OwnProps;

const Content: React.FC<Props> = (props) => {
  const { formatMessage } = useRegulatoryIntl();

  const {
    odds,
    isLocked,
    selectionText,
    isNonRunner,
    isStartingPriceMarket,
    isHandicap,
    isVacantTrap,
    shouldShowAddedToBetSlip,
    isSelected = false
  } = props;

  if (isNonRunner || isVacantTrap) return <>-</>;

  if (isLocked) {
    return <Icon icon={Padlock} size="x1" label={formatMessage(TXTWCL_SUSPENDED)} />;
  }

  if (!odds) {
    return isStartingPriceMarket ? (
      <strong aria-label={formatMessage(TXTWCL_Starting_Price)}>
        <Translation {...TXTWCL_SP} />
      </strong>
    ) : (
      <>-</>
    );
  }

  return (
    <span className={styles.selectionContent}>
      {selectionText && (
        <span
          aria-label={
            isHandicap && typeof selectionText === 'string'
              ? formatMessage(TXTWCL_handicap_value_N0, { 0: selectionText })
              : undefined
          }
        >
          {typeof selectionText === 'function' ? selectionText(isSelected) : selectionText}
        </span>
      )}
      <strong>
        {shouldShowAddedToBetSlip ? (
          <Translation {...TXTWCL_Added_To_Bet_Slip} />
        ) : (
          <Odds {...odds} />
        )}
      </strong>
    </span>
  );
};

export default Content;
